import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ViewContainerRef,
  NgZone
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators
} from "@angular/forms";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { GridDataResult } from "@progress/kendo-angular-grid";
import {
  SuccessEvent,
  RemoveEvent,
  FileInfo,
  UploadEvent,
  CancelEvent,
  FileRestrictions
} from "@progress/kendo-angular-upload";

import { ISubscription } from "rxjs/Subscription";

import { TabOpenService } from "src/app/services/tab-open.service";
import { CommonService } from "@shared/services/common";
import { MaterialItemService } from "src/app/fs-lte/services/price-book/material-item/material-item.service";
import { AuthService } from "src/app/services/auth.service";
import { FSliteTradeService } from "@fs/services/trades";

import { DataSharingLTE } from "@fs/services/data-sharing-lte";
import { CommonMethods } from "src/app/services/common.method";

import {
  MaterialItemModel,
  Item,
  Attachment,
  ExternalAttachment
} from "src/app/fs-lte/models/price-book/material-item.model";
import { PriceBucketModel } from "src/app/fs-lte/models/price-book/price-book.model";
import { Tabs } from "src/app/enums/tab.enum";
import { Constants } from "@shared/models/constants";
import { NotificationsService } from "@shared/services/notification";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { ProductItemType } from "@fs/enums/common-enums";
import { customJS } from "@fs/services/customjs";
import { forkJoin, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

declare var initBodyCustomScroll: any;

@Component({
  selector: "app-material-item-create",
  templateUrl: "./material-create.component.html",
  styleUrls: ["./material-create.component.scss"]
})
export class MaterialItemCreateComponent implements OnInit, AfterViewInit {
  private materialItemId: string = ""; //= "3EA6CCCA-2F34-4B68-914A-116A7F6A0D1E";
  private destroyTab: boolean = false;
  private dataLoaderCount = 3;
  private subscriptions: ISubscription[] = [];
  public isPageModeCreate: boolean = true;  
  public createMaterialItemForm: FormGroup;
  public baseUOMList: any;
  public priceBookAccountingCodesList: any;
  public replenishmentMethodTypeList: any;
  public itemManufacturersList: any;
  public attachments: GridDataResult = { data: [], total: 0 };
  public modalOptions: { showAttachment: boolean } = { showAttachment: false };
  /** update flag when file upload is in progress */
  public isUploadInProgress = false;
  public attachmentForm: FormGroup;
  public childCount: number = 0;
  public attachmentType: string = "Image";
  public categories = [];
  public materialItemModel: MaterialItemModel = new MaterialItemModel();
  public defaultImage: string = Constants.DefaultImagePaths.Material;
  public saveUrl: string;
  public removeUrl: string = "noUrl";
  public inputParams: any;
  public bucket: PriceBucketModel;
  public standardCostLabel: string = "0";
  public isEditAttachment: boolean = false;
  public editAttachmentForm: FormGroup;
  public format: string = "n2";
  public decimal: number = 2;
  public kendoUploadFileList: KendoUploadFileInfo[] = [];
  public deleteMessage: string = "";
  public deleteDataItem: any;
  public showDeleteConfirmation: boolean = false;
  public cancelConfirmation: boolean = false;
  public isUnsavedTriggered: boolean = false;
  public materialDetailsValid: boolean = true;
  public itemInformationDivValid: boolean = true;
  public pricingDivValid: boolean = true;
  public pageSizes = { pageSizes: [50, 100, 300], refresh: true };
  public state: DataSourceRequestState = {
    skip: 0,
    take: 50,
    sort: [
      {
        field: "Description",
        dir: "asc"
      }
    ]
  };
  public formatOptions: any = {
    style: "currency",
    currency: ""
  };
  public tabCounter: number;
  public defaultGUID = CommonMethods.GetID();
  /** used for attachment slider */
  public showAttachmentSlider: boolean = false;
  /** used for attachment slider */
  public slideIndex: number = 0;
  public qbVersion: string = "";
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: Constants.DefaultFileExtension,
    maxFileSize: Constants.DefaultFileSize.inbytes
  };
  public allowedextensionsforAttachment :string = '';
  public allowedsizeforAttachment: number = 0;
  public chkIsFreqUsed: string;
  public chkAllowPriceEd: string;
  public chkAllowDescEd: string;
  public chkIsTaxable: string;
  public chkSellProd: string;
  public chkIsRetnable: string;
  public chkBlkReorder: string;
  productItemType = ProductItemType;
  overlay: boolean = false;
  protected readonly ngUnsubscribe$ = new Subject();

  @ViewChild("tradeUploadImageBtn") tradeUploadImageBtn: ElementRef;
  @ViewChild("materilaDetailsDiv") materilaDetailsDiv: ElementRef;
  @ViewChild("itemInformationDiv") itemInformationDiv: ElementRef;
  @ViewChild("pricingDiv") pricingDiv: ElementRef;
  @ViewChild("attachImagePreview") attachImagePreview: ElementRef;
  @ViewChild("attachmentDragAndDropImage")
  attachmentDragAndDropImage: ElementRef;
  @ViewChild("attachmentDeletePreview") attachmentDeletePreview: ElementRef;
  @ViewChild("attachmentUploadImageBtn") attachmentUploadImageBtn: ElementRef;
  @ViewChild("grid") grid: any;

  constructor(
    private frmbuilder: FormBuilder,
    private tabOpen: TabOpenService,
    private $elementRef: ElementRef,
    private httpCommon: CommonService,
    private dataSharing: DataSharingLTE,
    private fSliteTradeService: FSliteTradeService,
    public commonMethods: CommonMethods,
    private auth: AuthService,
    private materialItemService: MaterialItemService,
    private toastr: NotificationsService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef,
    private zone: NgZone
  ) {    
    let subscription = this.tabOpen.routeToParentEvent.subscribe(response => {
      if (
        response.tabCounter == this.tabCounter &&
        response.event.split("|")[0] == "replaceTab" &&
        response.event.split("|")[1] == "discard"
      ) {
        $(this.$elementRef.nativeElement)
          .find(".tabs__content__box")
          .removeClass("dirty");
        this.CheckAndReplace();
        this.DestroySubscriptions();
      } else if (
        response.tabCounter == this.tabCounter &&
        response.event.split("|")[0] == "replaceTab" &&
        response.event.split("|")[1] == "save"
      ) {
        this.SaveMaterialItem();
      }
    });
    this.subscriptions.push(subscription);

    subscription = this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        this.SaveMaterialItem();
      }
    });
    this.subscriptions.push(subscription);

    subscription = this.tabOpen.ChangeComponentEvent.subscribe(response => {
      if (response.removeSubscriptions != undefined) {
        if (response.removeSubscriptions) {
          this.DestroySubscriptions();
        }
      }
    })
    this.subscriptions.push(subscription);
    
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();

    this.allowedextensionsforAttachment = this.commonMethods.FileExtensionArrayToCommaSeparatedString(this.uploadRestrictions.allowedExtensions);
    this.allowedsizeforAttachment = Constants.DefaultFileSize.inMegabytes;

    //#region Generate random Ids for controls
    this.chkIsFreqUsed = "ChkFreqUsed_" + CommonMethods.GenerateRandomID();
    this.chkAllowPriceEd = "ChkAllPriceEd_" + CommonMethods.GenerateRandomID();
    this.chkAllowDescEd = "ChkAllDescEd_" + CommonMethods.GenerateRandomID();
    this.chkIsTaxable = "ChkIsTaxable" + CommonMethods.GenerateRandomID();
    this.chkSellProd = "ChkSellProd" + CommonMethods.GenerateRandomID();
    this.chkIsRetnable = "ChkIsRetnable" + CommonMethods.GenerateRandomID();
    this.chkBlkReorder = "ChkBlkReorder" + CommonMethods.GenerateRandomID();
    //#endregion
  }

  //#region Lifecycle events

  ngOnInit() {
    if (this.inputParams.ID != undefined)
      this.materialItemId = this.inputParams.ID;

    this.LoadDefaultValues();
    this.isPageModeCreate = this.materialItemId.length > 0 ? false : true;
    this.saveUrl = this.materialItemService.UploadDocument();
    (this.materialItemId.length > 0) ? this.BindMaterialItem() : this.HideDataLoader();    
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.DestroySubscriptions();
  }

  ngAfterViewInit() {
    this.commonMethods.ApplyMaxLengthForKendoNumericBox(16);
  }

  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.createMaterialItemForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({
          dirty: isDirty,
          Index: this.tabCounter
        });
      }
    }
  }

  //#endregion

  //#region Private Methods
  private DestroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }

  private LoadDefaultValues() {
    const company = this.materialItemService.GetCompanyResources();
    const trade = this.fSliteTradeService.fetch("", this.state, "");

    this.overlay = true;
    forkJoin([company, trade]).pipe(takeUntil(this.ngUnsubscribe$))    
    .subscribe((res) => {
      // Company
      this.priceBookAccountingCodesList = res[0].PriceBookAccountingCodes;
      this.itemManufacturersList = res[0].Manufacturers;
      this.replenishmentMethodTypeList = res[0].CodeTypeData.ReplenishmentMethodType;
      this.baseUOMList = res[0].CodeTypeData.UOMOthersCode;
      this.baseUOMList.forEach(currentValue => {
        currentValue.Name = currentValue.Code + ' ' + currentValue.Name; // This is added to pass it to common Searchable dropdown
      });
      this.bucket = res[0].PriceBuckets.find(
        x => x.Name.toLowerCase() == "standard"
      );

      let baseUOM = this.createMaterialItemForm.controls["BaseUOM"].value;
      if (this.baseUOMList.filter(x => x.ID == baseUOM).length <= 0)
        this.createMaterialItemForm.controls["BaseUOM"].setValue("");

      // Trades
      this.categories = res[1].Children;
      setTimeout(() => {
        this.createMaterialItemForm.controls["Category"].setValue(
          this.materialItemModel.Category.ID
        );
        this.overlay = false;
        this.HideDataLoader();
      }, 1000);
    }, error => {
      this.overlay = false;
      this.HideDataLoader();
    });
    this.IntializeForm();
  }

  private IntializeForm() {
    this.createMaterialItemForm = this.frmbuilder.group({
      ID: new FormControl(null),
      ItemNumber: new FormControl("", this.commonMethods.noWhitespaceValidator),
      IsSellable: new FormControl(1),
      Description: new FormControl("", [
        this.commonMethods.noWhitespaceValidator
      ]),
      Category: new FormControl("", Validators.required),
      AccountingCode: new FormControl(""),
      Note: new FormControl(""),
      IsPriceEditAllowed: new FormControl(""),
      IsDescriptionEditAllowed: new FormControl(""),
      IsDiscountExcluded: new FormControl(""),
      IsTaxable: new FormControl(""),
      BaseUOM: new FormControl("", Validators.required),
      IsFrequentlyUsed: new FormControl(),
      StandardPrice: new FormControl(0, Validators.required),
      StandardCost: new FormControl(0),
      DefaultReplenishmentMethod: new FormControl("", Validators.required),
      LeadTime: new FormControl(),
      Manufacturer: new FormControl(""),
      ManufacturerPartNumber: new FormControl(""),
      IsReturnable: new FormControl(),
      BlockedFromReordering: new FormControl(null),
      IsAgreementExcluded: new FormControl("")
    });
  }

  private RemoveDocument(dataItem) {
    if (dataItem.ID == null || dataItem.ID == "") {
      this.attachments.data.splice(
        this.attachments.data.findIndex(x => x.Uid == dataItem.Uid),
        1
      );
    } else {
      this.attachments.data.splice(
        this.attachments.data.findIndex(x => x.ID == dataItem.ID),
        1
      );
    }
  }

  private CheckIsNotImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FilePath;
      if (!CommonMethods.CheckNullOrUndefined(dataItem["ExternalAttachment"])){
        fileName =dataItem["ExternalAttachment"]["AttachmentPath"];
      }
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        if (!this.commonMethods.ValidExtension(fileName, exts))
          return true;
        else
          return false;
      }
      else {
        if (!CommonMethods.CheckNullOrUndefined(dataItem.FilePath) && dataItem.FilePath.indexOf("https://mpsuitedevstore.blob.core.windows.net") < 0) {
          return true;
        }
      }
    }
    else
      return false;
  }

  private IntializeAttachmentForm(item = null) {
    if (item != null) {
      this.attachmentForm = this.frmbuilder.group({
        ID: new FormControl(item.ID),
        Uid: new FormControl(item.Uid),
        IsDefaultImage: new FormControl(item.IsDefaultImage),
        FileName: new FormControl(item.FileName, [
          Validators.required,
          this.commonMethods.noWhitespaceValidator,
          Validators.maxLength(50)
        ]),
        Description: new FormControl("", Validators.maxLength(50)),
        ImagePath: new FormControl(item.FilePath == null ? "" : item.FilePath),
        ExternalLink: new FormControl(
          CommonMethods.CheckNullOrUndefined(item.ExternalAttachment)
            ? ""
            : item.ExternalAttachment.ExternalUrl
        )
      });
    } else {
      this.attachmentForm = this.frmbuilder.group({
        ID: new FormControl(""),
        FileName: new FormControl("", [
          Validators.required,
          this.commonMethods.noWhitespaceValidator,
          Validators.maxLength(50)
        ]),
        ImagePath: new FormControl(""),
        ExternalLink: new FormControl(""),
        Description: new FormControl("", Validators.maxLength(50))
      });
    }
  }

  private BindMaterialItem() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.materialItemService.GetMaterialItem(this.inputParams.ID)
    .pipe(takeUntil(this.ngUnsubscribe$))
    .subscribe(
      response => {
        if (response != null) {
          this.isPageModeCreate = false;
          this.materialItemModel.ID = response.ID;
          this.materialItemModel.ItemNumber = response.ItemNumber;
          this.materialItemModel.IsFrequentlyUsed = response.IsFrequentlyUsed;
          this.materialItemModel.Description = response.Description;
          this.materialItemModel.IsSellable = response.IsSellable;
          this.materialItemModel.IsPriceEditAllowed =
            response.IsPriceEditAllowed;
          this.materialItemModel.IsDescriptionEditAllowed =
            response.IsDescriptionEditAllowed;
          this.materialItemModel.IsDiscountExcluded =
            response.IsDiscountExcluded;
          this.materialItemModel.IsTaxable = response.IsTaxable;
          this.materialItemModel.IsAgreementExcluded = response.IsAgreementExcluded;
          this.materialItemModel.Note = response.Note;
          this.materialItemModel.AccountingCode = response.AccountingCode;
          this.materialItemModel.Prices = response.Prices;
          var materialDetails = response.MaterialDetails;
          this.materialItemModel.MaterialDetails = new Item();

          this.materialItemModel.MaterialDetails.BaseUOM =
            materialDetails.BaseUOM;
          this.materialItemModel.MaterialDetails.StandardCost =
            materialDetails.StandardCost;
          this.materialItemModel.MaterialDetails.DefaultReplenishmentMethod =
            materialDetails.DefaultReplenishmentMethod;
          this.materialItemModel.MaterialDetails.LeadTime =
            materialDetails.LeadTime;
          this.materialItemModel.MaterialDetails.Manufacturer =
            materialDetails.Manufacturer;
          this.materialItemModel.MaterialDetails.ManufacturerPartNumber =
            materialDetails.ManufacturerPartNumber;
          this.materialItemModel.MaterialDetails.IsReturnable =
            materialDetails.IsReturnable;
          this.materialItemModel.MaterialDetails.BlockedFromReordering =
            materialDetails.BlockedFromReordering;
          this.materialItemModel.Attachments = response.Attachments;
          this.materialItemModel.ModifyDate = response.ModifyDate;
          // Needs to optimize
          if (response.Attachments != null) {
            for (let index = 0; index < response.Attachments.length; index++) {
              this.materialItemModel.Attachments[index][
                "IsImage"
              ] = !this.CheckIsNotImage(response.Attachments[index]);
              this.materialItemModel.Attachments[index][
                "UploadedBy"
              ] = response.Attachments[index].CreatedByUser;
            }
          }
          this.materialItemModel.Category = response.Category;
          this.SetFormValues(this.materialItemModel);
          // this.showCost(this.materialItemModel.Prices[0].Amount);
          this.HideDataLoader();
        } else this.HideDataLoader();
      },
      error => {
        this.HideDataLoader();
      }
    );
  }

  private BindModel() {
    this.materialItemModel.IsSellable = this.createMaterialItemForm.controls[
      "IsSellable"
    ].value;
    if (this.isPageModeCreate) {
      this.materialItemModel.ID = "";
      if (this.materialItemModel.IsSellable)
        this.materialItemModel.Prices = [
          Object.assign({
            Amount: this.createMaterialItemForm.controls["StandardPrice"].value,
            Bucket: this.bucket
          })
        ];
      else this.materialItemModel.Prices = [];
    } else {
      if (this.materialItemModel.IsSellable)
        this.materialItemModel.Prices = [
          Object.assign({
            ID:
              this.materialItemModel.Prices.length > 0
                ? this.materialItemModel.Prices[0].ID
                : "",
            Amount: this.createMaterialItemForm.controls["StandardPrice"].value,
            Bucket: this.bucket,
            IsDirty: !this.isPageModeCreate
          })
        ];
      else this.materialItemModel.Prices = [];
    }

    this.materialItemModel.ItemNumber = this.createMaterialItemForm.controls[
      "ItemNumber"
    ].value;

    if (this.createMaterialItemForm.controls["Manufacturer"].value != "")
      this.materialItemModel.MaterialDetails.Manufacturer = Object.assign({
        ID: this.createMaterialItemForm.controls["Manufacturer"].value
      });
    else this.materialItemModel.MaterialDetails.Manufacturer = null;

    if (this.createMaterialItemForm.controls["AccountingCode"].value != "")
      this.materialItemModel.AccountingCode = Object.assign({
        ID: this.createMaterialItemForm.controls["AccountingCode"].value
      });
    else this.materialItemModel.AccountingCode = null;

    if (this.createMaterialItemForm.controls["BaseUOM"].value != "")
      this.materialItemModel.MaterialDetails.BaseUOM = Object.assign({
        ID: this.createMaterialItemForm.controls["BaseUOM"].value
      });
    else this.materialItemModel.MaterialDetails.BaseUOM = null;

    if (this.createMaterialItemForm.controls["Category"].value != "")
      this.materialItemModel.Category = Object.assign({
        ID: this.createMaterialItemForm.controls["Category"].value
      });
    else this.materialItemModel.Category = null;

    if (
      this.createMaterialItemForm.controls["DefaultReplenishmentMethod"]
        .value != ""
    )
      this.materialItemModel.MaterialDetails.DefaultReplenishmentMethod = Object.assign(
        {
          ID: this.createMaterialItemForm.controls["DefaultReplenishmentMethod"]
            .value
        }
      );
    else
      this.materialItemModel.MaterialDetails.DefaultReplenishmentMethod = null;

    this.materialItemModel.Note = this.createMaterialItemForm.controls[
      "Note"
    ].value;
    this.materialItemModel.IsFrequentlyUsed = this.createMaterialItemForm.controls[
      "IsFrequentlyUsed"
    ].value;
    this.materialItemModel.Description = this.createMaterialItemForm.controls[
      "Description"
    ].value;
    this.materialItemModel.IsPriceEditAllowed = this.createMaterialItemForm.controls[
      "IsPriceEditAllowed"
    ].value;
    this.materialItemModel.IsDescriptionEditAllowed = this.createMaterialItemForm.controls[
      "IsDescriptionEditAllowed"
    ].value;
    this.materialItemModel.IsDiscountExcluded = false; // as every item must has to be discountable
    //this.createMaterialItemForm.controls["IsDiscountExcluded"].value;
    this.materialItemModel.IsAgreementExcluded = this.createMaterialItemForm.controls[
      "IsAgreementExcluded"
    ].value;
    this.materialItemModel.IsTaxable = this.createMaterialItemForm.controls[
      "IsTaxable"
    ].value;
    this.materialItemModel.MaterialDetails.StandardCost = this.createMaterialItemForm.controls[
      "StandardCost"
    ].value;
    this.materialItemModel.MaterialDetails.LeadTime = this.createMaterialItemForm.controls[
      "LeadTime"
    ].value;
    this.materialItemModel.MaterialDetails.ManufacturerPartNumber = this.createMaterialItemForm.controls[
      "ManufacturerPartNumber"
    ].value;
    this.materialItemModel.MaterialDetails.IsReturnable = this.createMaterialItemForm.controls[
      "IsReturnable"
    ].value;
    this.materialItemModel.MaterialDetails.BlockedFromReordering = this.createMaterialItemForm.controls[
      "BlockedFromReordering"
    ].value;
    this.materialItemModel.Attachments = this.attachments.data;
  }

  private SetFormValues(model: MaterialItemModel) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.createMaterialItemForm.controls["ItemNumber"].setValue(
      model.ItemNumber
    );
    this.createMaterialItemForm.controls["IsFrequentlyUsed"].setValue(
      model.IsFrequentlyUsed
    );
    this.createMaterialItemForm.controls["Description"].setValue(
      model.Description
    );
    this.createMaterialItemForm.controls["IsSellable"].setValue(
      model.IsSellable
    );
    this.createMaterialItemForm.controls["Note"].setValue(model.Note);
    this.createMaterialItemForm.controls["AccountingCode"].setValue(
      model.AccountingCode ? model.AccountingCode.ID : ""
    );
    this.createMaterialItemForm.controls["Category"].setValue(
      model.Category.ID
    );

    this.createMaterialItemForm.controls["IsPriceEditAllowed"].setValue(
      model.IsPriceEditAllowed
    );
    this.createMaterialItemForm.controls["IsDescriptionEditAllowed"].setValue(
      model.IsDescriptionEditAllowed
    );
    this.createMaterialItemForm.controls["IsDiscountExcluded"].setValue(
      model.IsDiscountExcluded
    );
    this.createMaterialItemForm.controls["IsAgreementExcluded"].setValue(
      model.IsAgreementExcluded
    );
    this.createMaterialItemForm.controls["IsTaxable"].setValue(model.IsTaxable);
    this.createMaterialItemForm.controls["BaseUOM"].setValue(
      model.MaterialDetails.BaseUOM ? model.MaterialDetails.BaseUOM.ID : ""
    );
    this.createMaterialItemForm.controls["StandardPrice"].setValue(
      model.Prices[0] ? model.Prices[0].Amount : 0
    );
    this.createMaterialItemForm.controls["StandardCost"].setValue(
      model.MaterialDetails.StandardCost
    );
    this.createMaterialItemForm.controls["DefaultReplenishmentMethod"].setValue(
      model.MaterialDetails.DefaultReplenishmentMethod
        ? model.MaterialDetails.DefaultReplenishmentMethod.ID
        : ""
    );
    this.createMaterialItemForm.controls["LeadTime"].setValue(
      model.MaterialDetails.LeadTime
    );
    this.createMaterialItemForm.controls["Manufacturer"].setValue(
      model.MaterialDetails.Manufacturer
        ? model.MaterialDetails.Manufacturer.ID
        : CommonMethods.GetID()
    );
    this.createMaterialItemForm.controls["ManufacturerPartNumber"].setValue(
      model.MaterialDetails.ManufacturerPartNumber
    );
    this.createMaterialItemForm.controls["IsReturnable"].setValue(
      model.MaterialDetails.IsReturnable
    );
    this.createMaterialItemForm.controls["BlockedFromReordering"].setValue(
      model.MaterialDetails.BlockedFromReordering
    );
    this.attachments.data = model.Attachments;
    this.attachments.total = model.Attachments.length;
    if (model.Attachments.find(x => x.IsDefaultImage == true) != undefined)
      this.defaultImage =
        model.Attachments.find(x => x.IsDefaultImage == true) != undefined
          ? model.Attachments.find(x => x.IsDefaultImage == true).FilePath
          : "";
    this.ShowCost();
    if (!this.isPageModeCreate) {
      if (
        this.baseUOMList != undefined &&
        this.baseUOMList.filter(
          x => x.ID == this.createMaterialItemForm.controls["BaseUOM"].value
        ).length <= 0
      )
        this.createMaterialItemForm.controls["BaseUOM"].setValue("");
    }
    this.HideDataLoader();
  }

  private ValidateInputExt(input, exts) {
    var fileName = input.value.toLowerCase();
    return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
      fileName
    );
  }

  private ReadURL(
    input,
    formType,
    DragAndDropImage,
    UploadImageBtn,
    ImagePreview,
    DeletePreview
  ) {
    let exts = this.uploadRestrictions.allowedExtensions;
    if (input.files && input.files[0]) {
      if (!this.ValidateInputExt(input, exts)) {
        this.toastr.error(
          "Sorry, uploaded file is invalid, allowed extensions are: " +
            exts.join(", "),
          "Error"
        );
        $(input).val("");
        return;
      }
      if(input.files[0].size > 4194304) // 4 m.b.
      {
        this.toastr.error("Sorry, File size is too large. Maximum file size permitted is 4 MB", "Error");
        $(input).val("");
        return;
      }
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      let postData = new FormData();
      postData.append("files", input.files[0]);
      this.isUploadInProgress = true;
      this.materialItemService.UploadImage(postData)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        response => {
          this.editAttachmentForm.controls["ImagePath"].patchValue(
            response[0].StorageLocation
          );
          this.editAttachmentForm.controls["FileName"].patchValue(
            response[0].FileName
          );
          $(this.attachImagePreview.nativeElement).show();
          $(this.attachmentDragAndDropImage.nativeElement).hide();
          this.isUploadInProgress = false;
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        },
        error => {
          this.isUploadInProgress = false;
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
    }
  }

  private IntializeEditAttachment(item = null) {
    if (CommonMethods.CheckNullOrUndefined(item.ExternalAttachment))
      this.attachmentType = item.FileName == "" ? "Link" : "Image";
    else
      this.attachmentType =
        item.ExternalAttachment.ExternalUrl == "" ? "Image" : "Link";

    this.editAttachmentForm = this.frmbuilder.group({
      ID: new FormControl(item.ID),
      Description: new FormControl(item.Description),
      ImagePath: new FormControl(item.FilePath),
      FileName: new FormControl(item.FileName),
      ExternalLink: new FormControl({value :
        CommonMethods.CheckNullOrUndefined(item.ExternalAttachment)
          ? ""
          : item.ExternalAttachment.ExternalUrl, disabled: true}
      ),
      ExternalAttachmentID: new FormControl(
        !CommonMethods.CheckNullOrUndefined(item.ExternalAttachment) ? item.ExternalAttachment.ID
        : CommonMethods.GetID()),
      IsDefaultImage: new FormControl(item.IsDefaultImage),
      Uid: new FormControl(item.Uid)
    });

    if (item.FilePath != "" && item.FilePath != null) {
      setTimeout(() => {
        $(this.attachImagePreview.nativeElement).show();
        $(this.attachmentDragAndDropImage.nativeElement).hide();
      }, 100);
    }
  }

  private ViewDetails(dataItem) {    
    if (this.attachments.data.findIndex(x => x.ID == dataItem.ID) > -1) {
      this.modalOptions.showAttachment = true;
      this.IntializeAttachmentForm(dataItem);
    }
    this.modalOptions.showAttachment = true;
  }

  private HideDataLoader() {
    this.dataLoaderCount = this.dataLoaderCount - 1;
    if (this.dataLoaderCount <= 0) {
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    }
  }

  private CheckAndReplace() {
    if (this.materialItemModel.ID != "") {
      this.tabOpen.ReplaceTab(
        {
          CurrentTabIndex: this.tabCounter,
          newTabInfo: {
            tabId: Tabs.FsLiteMaterialItemDetail,
            params: { ID: this.materialItemModel.ID },
            tabTitle: "Material Item - " + this.materialItemModel.ItemNumber
          }
        },
        true
      );
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
      let info = this.tabOpen.TabInfo;
      this.tabOpen.OpenTab({
        tabId: Tabs.FsLitePriceBookList,
        params: {},
        tabTitle: "Products"
      });
    }
  }

  //#endregion

  //#region Public methods

  public UploadEventHandler(e: UploadEvent) {
    this.isUploadInProgress = true;
  }

  public CancelEventHandler(e: CancelEvent) {
    this.isUploadInProgress = false;
  }
  
  public RemoveEventHandler(e: RemoveEvent) {
    const index = this.kendoUploadFileList.indexOf(
      this.kendoUploadFileList.find(x => x.fileInfo.uid == e.files[0].uid)
    );
    if (index > -1) {
      this.kendoUploadFileList.splice(index, 1);
    }
  }

  public SuccessEventHandler(e: SuccessEvent) {
    if (e.operation == "upload") {
      let fileInfo = e.response.body[0];
      var info = new KendoUploadFileInfo();

      info.fileInfo = e.files[0];
      info.attachmentInfo = new Attachment();
      info.attachmentInfo.FileName = fileInfo.FileName;
      info.attachmentInfo.FilePath = fileInfo.StorageLocation;
      if (this.kendoUploadFileList.length > 0 && this.kendoUploadFileList.find(x => x.attachmentInfo.FileName == info.attachmentInfo.FileName) != undefined) {
        e.preventDefault();
        this.toastr.error(
          "This file has already been attached, Please rename and try again."
        );
      }
      else {
        this.kendoUploadFileList.push(info);
      }
      this.isUploadInProgress = false;
    }
  }

  public ErrorEventHandler(e: any) {
    if (e.response != null) {
      this.toastr.showMultiLineError(e.response.error.Message, "Error");
    } else {
      this.toastr.showMultiLineError("Something went wrong!", "Error");
    }
    this.isUploadInProgress = false;
  }

  public async AddAttachment(txtLinkUrl) {   
    var totalCount = this.attachments.total;
    /* New attachment */
    let fileDescription = this.attachmentForm.controls["Description"].value;
    if (this.attachmentType == "Image") {
      this.kendoUploadFileList.forEach(x => {
        x.attachmentInfo.Description = fileDescription;
        x.attachmentInfo.IsDefaultImage = false;
        x.attachmentInfo.Uid = x.fileInfo.uid;
        x.attachmentInfo.IsDirty = false;
        x.attachmentInfo.ExternalAttachment = null;
        x.attachmentInfo["IsImage"] = !this.CheckIsNotImage(x.attachmentInfo);
        this.attachments.data.push(x.attachmentInfo);
        totalCount++;
      });
      this.CloseModal("Attachment");
      this.attachments.total = totalCount;
    } else {
      let response = await this.SaveExternalUrl(txtLinkUrl.value);
      if (response != null) {
        let attachment = new Attachment();
        attachment.IsDirty = false;
        attachment.Description = fileDescription;
        if (response.length > 0) {
          attachment.FilePath = response[0]["StorageLocation"];
          attachment.FileName = response[0]["FileName"];
          attachment.ExternalAttachment.AttachmentPath =
            response[0]["StorageLocation"];
          attachment.ExternalAttachment.ExternalUrl = txtLinkUrl.value;
          attachment.ExternalAttachment.FileName = response[0]["FileName"];
        } else {
          attachment.FileName = response.FileName;
          attachment.FilePath = response.AttachmentPath;
          attachment.ExternalAttachment.ID = response.ID;
          attachment.ExternalAttachment.ExternalUrl = response.ExternalUrl;
          attachment.ExternalAttachment.AttachmentPath =
            response.AttachmentPath;
          attachment.ExternalAttachment.FileName = response.FileName;
          attachment.ExternalAttachment.ModifyDate = response.ModifyDate;
        }
        attachment.ExternalAttachment.IsDirty = false;
        attachment.Uid = Math.floor(Math.random() * 100).toString();
        attachment.IsDefaultImage = false;
        attachment["IsImage"] = !this.CheckIsNotImage(attachment);
        this.attachments.data.push(attachment);
        this.CloseModal("Attachment");
      }
    }
  }

  public async EditDocument() {
    let currentID = this.editAttachmentForm.controls["ID"].value;
    let currentUid = this.editAttachmentForm.controls["Uid"].value;
    let externalURL = this.editAttachmentForm.controls["ExternalLink"].value;
    let filePath = this.editAttachmentForm.controls["ImagePath"].value;
    let fileName = this.editAttachmentForm.controls["FileName"].value;
    let externalAttachmentID = this.editAttachmentForm.controls["ExternalAttachmentID"].value;
    let externalAttachment = new ExternalAttachment();
    externalAttachment.ID = externalAttachmentID;
    let isValid = true;
    if (this.attachmentType != "Image" && externalURL != "") {
      let response = await this.SaveExternalUrl(externalURL);
      if (response != null) {
        let isDefaultImage=this.editAttachmentForm.controls["IsDefaultImage"].value;
        if (response.length > 0) {
          filePath = response[0]["StorageLocation"];
          fileName = response[0]["FileName"];
          externalAttachment.AttachmentPath = response[0]["StorageLocation"];
          externalAttachment.ExternalUrl = externalURL;
          externalAttachment.FileName = response[0]["FileName"];
        } else {
          fileName = response.FileName;
          filePath = response.AttachmentPath;
          externalAttachment.ID = response.ID;
          externalAttachment.ExternalUrl = response.ExternalUrl;
          externalAttachment.AttachmentPath = response.AttachmentPath;
          externalAttachment.FileName = response.FileName;
          externalAttachment.ModifyDate = response.ModifyDate;          
        }
        if(isDefaultImage){
          this.defaultImage=filePath;
        }
      } else {
        isValid = false;
      }
    } else {
      externalAttachment = null;
    }

    if (isValid) {
      if (
        this.attachments.data.find(
          x => currentID != null && currentID != "" && x.ID == currentID
        ) != undefined ||
        this.attachments.data.find(x => x.Uid == currentUid) != undefined
      ) {
        var attach = {
          ID: currentID,
          Description: this.editAttachmentForm.controls["Description"].value,
          FilePath: filePath,
          FileName: fileName,
          IsDefaultImage: this.editAttachmentForm.controls["IsDefaultImage"]
            .value,
          Uid: currentUid, // this.editAttachmentForm.controls["Uid"].value,
          ExternalAttachment: externalAttachment,
          IsImage: false,
          IsDirty: true
        };
        if (attach.FilePath.length <= 0) {
          this.RemoveDocument(attach);
        } else {
          var idx = this.attachments.data.findIndex(x => (currentID != null && currentID != "" && x.ID == currentID)
            || ((currentID == null || currentID == "") && x.Uid == currentUid));
          attach.IsImage = !this.CheckIsNotImage(attach);
          this.attachments.data[idx] = attach;
        }
      }
      this.CloseModal("EditAttachment");
    }
  }

  public SaveExternalUrl(url: string): Promise<any> {
    return new Promise(resolve => {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      this.materialItemService
        .UploadExternalDocument(JSON.stringify(url.trim()))
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          response => {
            this.HideDataLoader();
            resolve(response);
          },
          error => {
            this.HideDataLoader();
            if (!CommonMethods.CheckNullOrUndefined(error.error))
              this.toastr.showMultiLineError(error.error.Message, "Error");
            resolve(null);
          }
        );
    });
  }

  public RemovePreview(
    type,
    ImageFileControl1,
    ImageFileControl2,
    DragAndDropImage,
    UploadImageBtn,
    ImagePreview,
    DeletePreview
  ) {
    $(ImageFileControl1).val("");
    $(ImageFileControl2).val("");
    this.editAttachmentForm.controls["ImagePath"].patchValue("");

    //$(ImagePreview).attr('src', '');
    $(DeletePreview).hide();
    $(ImagePreview).hide();
    $(DragAndDropImage).show();
    $(UploadImageBtn).hide();
  }

  

  public OpenAttachment(e) {
    e.stopPropagation();
    this.kendoUploadFileList = [];
    this.modalOptions.showAttachment = true;
    this.attachmentType = "Image";
    this.IntializeAttachmentForm();
  }

  public ImageUploaded(
    selfRef,
    formType,
    DragAndDropImage,
    UploadImageBtn,
    ImagePreview,
    DeletePreview
  ) {
    this.ReadURL(
      selfRef.target,
      formType,
      DragAndDropImage,
      UploadImageBtn,
      ImagePreview,
      DeletePreview
    );
  }

  public ChangeIsDefault(event, dataItem) {
    let oldDefaultImage = this.attachments.data.find(x => x.IsDefaultImage);
    this.attachments.data.forEach(x => {
      x.IsDirty = false;
      if (x == dataItem) {
        x.isDirty = !CommonMethods.CheckNullOrUndefined(x.ID);
        x.IsDefaultImage = $(event.target)[0].checked;
        if ($(event.target)[0].checked) {
          this.defaultImage = x.FilePath;
        } else {
          this.defaultImage = Constants.DefaultImagePaths.Material;
        }
      } else {
        if (x == oldDefaultImage) {
          x.isDirty = !CommonMethods.CheckNullOrUndefined(oldDefaultImage.ID);
          x.IsDefaultImage = false;
        }
      }
    });
  }

  public SaveMaterialItem() {
    if (this.createMaterialItemForm.valid) {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      this.BindModel();
      if (this.materialItemModel.ID.length > 0) {
        this.materialItemService
          .EditMaterialItem(this.materialItemModel)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe(
            r => {
              if (
                $(this.$elementRef.nativeElement)
                  .find(".tabs__content__box")
                  .hasClass("dirty")
              ) {
                $(this.$elementRef.nativeElement)
                  .find(".tabs__content__box")
                  .removeClass("dirty");
              }
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
              this.dataSharing.ItemChangeEvent();
              setTimeout(() => {
                if (this.destroyTab) {
                  this.tabOpen.DestroyTab(this.tabCounter);
                } else {
                  this.tabOpen.ReplaceTab({
                    CurrentTabIndex: this.tabCounter,
                    newTabInfo: {
                      tabId: Tabs.FsLiteMaterialItemDetail,
                      params: { ID: this.materialItemModel.ID },
                      tabTitle:
                        "Material Item - " + this.materialItemModel.ItemNumber
                    }
                  });
                }
              }, 300);
              this.DestroySubscriptions();
              var successMessage = this.isPageModeCreate
                ? "Material item " + this.materialItemModel.ItemNumber + " created"
                : "Material item " + this.materialItemModel.ItemNumber + " updated";
              this.toastr.success(successMessage, "Success!");
            },
            error => {
              this.destroyTab = false;
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
              this.toastr.showMultiLineError(error.error.Message, "Error");
            }
          );
      } else {
        this.materialItemService
          .CreateMaterialItem(this.materialItemModel)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe(
            r => {
              if (
                $(this.$elementRef.nativeElement)
                  .find(".tabs__content__box")
                  .hasClass("dirty")
              ) {
                $(this.$elementRef.nativeElement)
                  .find(".tabs__content__box")
                  .removeClass("dirty");
              }
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
              var successMessage = this.isPageModeCreate
                ? "Material item " + this.materialItemModel.ItemNumber + " created"
                : "Material item " + this.materialItemModel.ItemNumber + " updated";
              this.toastr.success(successMessage, "Success!");
              this.dataSharing.ItemChangeEvent();
              setTimeout(() => {
                if (this.destroyTab) {
                  this.tabOpen.DestroyTab(this.tabCounter);
                } else {
                  this.tabOpen.ReplaceTab({
                    CurrentTabIndex: this.tabCounter,
                    newTabInfo: {
                      tabId: Tabs.FsLiteMaterialItemDetail,
                      params: { ID: r.ID },
                      tabTitle:
                        "Material - " + this.materialItemModel.ItemNumber
                    }
                  });
                }
              }, 300);
              this.DestroySubscriptions();
            },
            error => {
              this.destroyTab = false;
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
              this.toastr.showMultiLineError(error.error.Message, "Error");
            }
          );
      }
    } else {
      this.destroyTab = false;
      this.commonMethods.markFormGroupTouched(this.createMaterialItemForm);
      this.zone.runOutsideAngular(() => {
        customJS.verifyBoxes(this.$elementRef.nativeElement);
      });
    }
  }

  public ShowCost() {
    this.standardCostLabel = this.createMaterialItemForm.controls[
      "StandardCost"
    ].value;
  }

  public OpenEdit(dataItem) {
    this.IntializeEditAttachment(dataItem);
    this.isEditAttachment = true;
  }

  public ChangeAttachmentType(value) {
    this.attachmentType = value;
  }

  public CloseModal(type) {
    if (type == "Attachment") {
      if (this.attachmentForm.dirty) {
        //  this.tabOpen.DestroyTab(this.tabCounter, "modal")
        this.modalOptions.showAttachment = false;
      } else {
        this.modalOptions.showAttachment = false;
      }
    }
    if ((type = "EditAttachment")) {
      //  this.tabOpen.DestroyTab(this.tabCounter, "modal")
      this.isEditAttachment = false;
    }
  }

  public Delete(dataItem) {
    this.deleteDataItem = dataItem;
    this.showDeleteConfirmation = true;
    if (this.attachments.data.findIndex(x => x.ID == dataItem.ID) > -1) {
      this.deleteMessage = "This action will permanently delete the record.";
    }
  }

  public ConfirmDelete(ref) {
    this.showDeleteConfirmation = false;
    if (ref) {
      let dataItem = this.deleteDataItem;
      if (dataItem.ID == null || dataItem.ID == "") {
        this.attachments.data.splice(
          this.attachments.data.findIndex(x => x.Uid == dataItem.Uid),
          1
        );
      } else {
        this.attachments.data.splice(
          this.attachments.data.findIndex(x => x.ID == dataItem.ID),
          1
        );
      }
    } else {
      this.deleteDataItem = null;
    }
  }

  public CancelAction() {
    if (this.materialItemModel.ID != "") {
      this.tabOpen.ReplaceTab({
        CurrentTabIndex: this.tabCounter,
        newTabInfo: {
          tabId: Tabs.FsLiteMaterialItemDetail,
          params: { ID: this.materialItemModel.ID },
          tabTitle: "Material Item - " + this.materialItemModel.ItemNumber
        }
      });
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
    }
    }

   /** used for attachment slider */
   ViewAttachmentSlide(idx: number) {     
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }
  /** used for attachment slider */
  CloseAttachmentSlider() {
    this.showAttachmentSlider = false;
  }

  //#endregion
}

export class KendoUploadFileInfo {
  public fileInfo: FileInfo;
  public attachmentInfo: Attachment;
}
